class RecentlyViewedRenderer {

    render(selector) {

        const container = document.querySelector(selector);

        if (!container) return;

        const products = window.RecentlyViewedStorage.get();

        if (!products.length) {
            container.innerHTML = '';
            return;
        }
        

        container.innerHTML = `
            <div class="recently-viewed-products-container">
            <div class="row recently-viewed-wrapper">

                <div class="recently-viewed-header">
                    <h3>Recently Viewed</h3>
                    <section>
                        Don't lose track of great finds—view your recently explored products.
                    </section>
                </div>

                <div class="recently-viewed-carousel">

                    <button class="rv-arrow rv-prev" aria-label="Previous">
                        &#10094;
                    </button>

                    <div class="rv-track-wrapper">

                        <div class="rv-track">

                            ${products.map(product => `
                                <a href="${product.url}" class="recently-viewed-card">

                                    <div class="recently-viewed-image">
                                        <img
                                            src="${product.image}"
                                            alt="${product.title}"
                                            loading="lazy">
                                    </div>

                                    <div class="recently-viewed-content">
                                        <h3>${product.title}</h3>

                                        <span class="recently-viewed-price">
                                            ${product.price}
                                        </span>
                                    </div>

                                </a>
                            `).join('')}

                        </div>

                    </div>

                    <button class="rv-arrow rv-next" aria-label="Next">
                        &#10095;
                    </button>

                </div>

            </div>
            </div>
        `;

        this.initCarousel(container);

    }

    initCarousel(container) {

        const wrapper = container.querySelector('.rv-track-wrapper');
        const track = container.querySelector('.rv-track');
        const prev = container.querySelector('.rv-prev');
        const next = container.querySelector('.rv-next');

        if (!wrapper || !track) return;

        let index = 0;

        const getGap = () => {

            const style = getComputedStyle(track);

            return parseInt(style.columnGap || style.gap || 24);

        };

        const getCardWidth = () => {

            const card = track.querySelector('.recently-viewed-card');

            if (!card) return 0;

            return card.offsetWidth + getGap();

        };

        const getVisibleCards = () => {

            const card = track.querySelector('.recently-viewed-card');

            if (!card) return 1;

            return Math.max(
                1,
                Math.floor(
                    wrapper.offsetWidth / (card.offsetWidth + getGap())
                )
            );

        };

        const update = () => {

            const width = getCardWidth();

            track.style.transform = `translateX(-${index * width}px)`;

            const visible = getVisibleCards();

            const maxIndex = Math.max(
                0,
                track.children.length - visible
            );

            prev.style.visibility = index === 0 ? 'hidden' : 'visible';

            next.style.visibility =
                index >= maxIndex ? 'hidden' : 'visible';

        };

        next.addEventListener('click', () => {

            const visible = getVisibleCards();

            const maxIndex = Math.max(
                0,
                track.children.length - visible
            );

            if (index < maxIndex) {

                index++;

                update();

            }

        });

        prev.addEventListener('click', () => {

            if (index > 0) {

                index--;

                update();

            }

        });

        window.addEventListener('resize', update);

        update();

    }

}

window.RecentlyViewedRenderer = new RecentlyViewedRenderer();

document.addEventListener('DOMContentLoaded', () => {
    window.RecentlyViewedRenderer.render('#recently-viewed-products');
});